import React, { Component }
    from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter }
    from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from './../../Header';
import $ from 'jquery';
import CcMultiChosen from './../../CcMultiChosen';
import config from 'react-global-configuration';
import CryptoJS from 'crypto-js';
class ManageReferer extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            checkedDemoUser: localStorage.getItem('checkedDemoUser') ? localStorage.getItem('checkedDemoUser') : 0,
            referrer_customer: [],
            activePage: 1,
            item_count: '',
            item_count: '',
            studio_cc: '',
            referrer_id: '',
            studio_name: '',
            res_search: '',
            isLoadMore: 1,
            activePage: 1,
            loading: 1

        }
        this.handlePageChange = this.handlePageChange.bind(this);
        this.renderStodioList = this.renderStodioList.bind(this);
        this.getSelectedCcStudio = this.getSelectedCcStudio.bind(this);
        this.getAllStudio = this.getAllStudio.bind(this);
        this.keywordChange = this.keywordChange.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    getAllStudio() {
        fetch(this.state.apiUrl + '/partnerRest/getStudio/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                this.setState({
                    hrowners: responseJson
                })
            })
    }

    renderStodioList() {
        if (this.state.hrowners) {
            return (
                <CcMultiChosen onChange={this.getSelectedCcStudio}>
                    {
                        this.state.hrowners.map((owner, i) => <option key={i} value={owner.id}>{owner.name}</option>)}
                </CcMultiChosen>
            )
        }
        return <p>Loading owner...</p>
    }

    getSelectedCcStudio() {
        var selectedCcValues = [];
        $("#ccselectlist :selected").each(function () {
            selectedCcValues.push($(this).val());
        });
        //alert(selectedCcValues);
        this.setState({ studio_cc: selectedCcValues });
    }

    linktoRefereer(referrer_id) {
        this.setState({ referrer_id: referrer_id });
    }

    linkcustomer() {
        const fd = new FormData;
        fd.append('partner_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/partnerRest/linkCustomer/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.error == true) {
                    this.setState({
                        responseTxt: findresponse.msg
                    });
                } else {
                    this.setState({
                        hrowners: findresponse.studio
                    })
                }
                this.getResellerCustomers();
            })
    }

    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/PartnerRest/manageReferer/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        referrer_customer: findresponse.referrer,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }

    getResellerCustomers(page = 1) {
        fetch(this.state.apiUrl + '/PartnerRest/manageReferer/page/' + page + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((res) => {
                res = this.rawjsonparse(res, 1);
                this.setState({
                    loading: 0,
                    referrer_customer: res.referrer,
                    item_count: res.item_count,
                    offset: res.offset,
                    off_count: res.off_count,
                    setPage: 'yes'
                })
            })
    }
    keywordChange(event) {
        var obj = this;
        this.setState({ res_search: event.target.value });
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.getResellerCustomers();
        }, 500);
    }
    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/PartnerRest/manageReferer/userAuthKey/' + this.state.userAuthKey + '/page/' + pageNumber, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.referrer.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                }
                else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    referrer_customer: this.state.referrer_customer.concat(findresponse.referrer),
                })

            })

    }

    /*
    * Author : P ANIL KUMAR REDDY
    * Er : 63630
    * Email : anil@muvi.com
    * Function is for check and uncheck filter data to show in dashboard
    */
    checkedDemouser(event) {
        let isChecked = event.target.checked;
        console.log(event.target.checked);
        if (event.target.checked == true) {
            localStorage.setItem('checkedDemoUser', 1);
            this.setState({ demouser: event.target.checked }, function () {
                this.getResellerCustomers();
            });
        } else {
            localStorage.setItem('checkedDemoUser', 0);
            this.setState({ demouser: event.target.checked }, function () {
                this.getResellerCustomers();
            });
        }
    }

    componentDidMount() {
        document.title = "Intranet | Referrer";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        if (localStorage.getItem('checkedDemoUser') == 1) {
            console.log(1);
            this.state.demouser = true;
            console.log(this.state.demouser);
        } else {
            this.state.demouser = false;
            console.log(0);
            console.log(this.state.demouser);
        }
        this.getResellerCustomers();
        this.getAllStudio();
    }
    getReferStores(refferStudios) {
        if (refferStudios.length > 0) {
            return (
                <p>
                    <ul className="mantis">
                        {refferStudios.map((studio, key) =>
                            <li> {studio.name} </li>
                        )}
                    </ul>
                </p>
            )
        } else {
            return (
                <p>N/A</p>
            )
        }
    }

    getManageReferer() {
        if (this.state.loading) {
            return (
                <div>
                    <div class="loader-new"></div>
                </div>
            )
        }
        else {
            return (
                <div class="list_check">
                    <div class="tickets hidden-sm margin_top_less">
                        <ul class="tickets_head adv">
                            <li class="intra_col_10">Name</li>
                            <li class="intra_col_10">Company</li>
                            <li class="intra_col_15">Email</li>
                            <li class="intra_col_15">Linked to Customers</li>
                            <li class="intra_col_15">Commission Earned</li>
                            <li class="intra_col_15">Commission Paid</li>
                            <li class="intra_col_18">To be Paid</li>
                            <li class="intra_col_1 onclick-menu" tabindex="0">
                                <i class="far fa-ellipsis-v"></i>
                                <ul class="onclick-menu-content text-left demouser-popup">
                                    <input type="checkbox" defaultChecked={this.state.checkedDemoUser == 1 ? 'checked' : ''} onChange={event => this.checkedDemouser(event)} />
                                    <label class="demouser-checkbox">Show Demo User</label>
                                </ul>
                            </li>

                        </ul>
                        {
                            this.state.referrer_customer.map((refer, key) =>
                                <ul class="tickets_number" >
                                    <li class="intra_col_10 text-inded">{refer.name}</li>
                                    <li class="intra_col_10 text-inded">{refer.company_name ? refer.company_name : '--'}</li>
                                    <li class="intra_col_15 text-inded">{refer.email}</li>
                                    <li class="intra_col_15">
                                        {this.getReferStores(refer.studio)}
                                        <a href="#" data-toggle="modal" data-target="#myModal" onClick={() => this.linktoRefereer(refer.portaluser_id)}>Link Customer</a></li>
                                    <li class="intra_col_15">$ {(refer.total_commision > 0) ? refer.total_commision : '0'}</li>
                                    <li class="intra_col_15">$ {(refer.total_paid > 0) ? refer.total_paid : '0'}</li>
                                    <li class="intra_col_18">$ {(refer.tobe_paid > 0) ? refer.tobe_paid : '0'}</li>
                                </ul>
                            )
                        }
                    </div>
                    <div class="custmer_mob hidden-md">
                        {
                            this.state.referrer_customer.map((refer, key) =>
                                <div class="custmer_list_mob">
                                    <h4 class="list_title">{refer.name}</h4>
                                    <div> {this.getReferStores(refer.studio)}<br />
                                        <a href="#" data-toggle="modal" data-target="#myModal" onClick={() => this.linktoRefereer(refer.portaluser_id)}>Link Customer</a> </div>
                                </div>
                            )
                        }
                    </div>
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    {/* {this.loadMorecount()} */}


                </div>
            )
        }
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />

            )
        }
        return (
            <div>
                <Header brecum_name="Partners" brecum_page="Referrer" />
                <div class="modal fade" id="myModal" role="dialog">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                <h4 class="modal-title">Link customer to referrer</h4>
                            </div>
                            <div class="modal-body">
                                <p class="red">{this.state.responseTxt ? this.state.responseTxt : ''}</p>
                                {this.renderStodioList()}
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-default" data-dismiss="modal" onClick={() => this.linkcustomer()}>Link to referrer</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <--modal start-!> */}
                <div class="right_col">
                    <section class="customer">
                        <div id="exTab1" class="container">
                            <ul class="nav nav-pills">
                                <li>
                                    <Link to={`/allreseller/`} name={"max"} class="tab">All</Link>
                                </li>
                                <li>
                                    <Link to={`/reseller/`} name={"max"} class="tab">Reseller</Link>
                                </li>
                                <li class="active"><Link to={`/managereferer/`} name={"max"} class="tab">Referrer</Link>
                                </li>
                                <li>
                                    <Link to={`/affiliates/`} name={"max"} class="tab">Affiliates</Link>
                                </li>
                            </ul>
                            <div class="tab-content clearfix margin_less">
                                <div class="tab-pane active" id="Leads">
                                </div>
                            </div>
                        </div>
                        {this.getManageReferer()}
                    </section>
                </div>
            </div>
        )
    }
}
export default ManageReferer;


// WEBPACK FOOTER //
// ./src/components/partner/manageReferer.js